import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import IntakeFormPage from "../pages/intake/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/intake",
    element: <IntakeFormPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;